module.exports = __webpack_public_path__ + "img/cover19.9b81dc68.png";